import src from "IMAGE";
export default { src, width: 1033, height: 88, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAwTHWcKERpdChEaXAkPF05nb3ePvMrY/8HP3P/AzNf1ke0OQNsSZ0cAAAAASUVORK5CYII="};
